import { getRuntimeConfig } from '../../lib/runtimeConfig';
import { buildCommunicationStatusUrl } from '../../helpers/urls';

/* istanbul ignore next */
const publicRuntimeConfig = getRuntimeConfig() || {};

const testStatus = {
  data: {
    communication_exists: true,
    submitted_at: '2025-10-27T14:35:01Z',
    submitted_by: 'Nadalie Portland',
  },
};

export default async function getProjectCommunicationStatus(
  companyId: number,
  bidPackageId: number,
  loginInformationId: number,
  userCompanyId: number | null
) {
  if (
    publicRuntimeConfig.mockCommunicationStatus &&
    !publicRuntimeConfig.isProd
  ) {
    return testStatus;
  }
  const url = buildCommunicationStatusUrl(
    bidPackageId,
    companyId,
    loginInformationId,
    userCompanyId
  );
  if (!url) {
    return null;
  }
  const result = await fetch(url);
  if (result.ok) {
    return await result.json();
  }
  return null;
}
